import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../global/theme/tokens';
import MoneyLabel from '../../label/MoneyLabel';

const ContractRevenue = ({ specials, amountMode = 'net' }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  if (!specials) return null;

  const isNet = amountMode === 'net';
  const monthly = isNet ? specials.monthlyFixedNet : specials.monthlyFixedGross;
  const annual = isNet ? specials.annualizedNet : specials.annualizedGross;
  const invoiced = isNet ? specials.invoiceTotalNet : specials.invoiceTotalGross;

  return (
    <Box className="flex flex-col gap-1.5">
      <Typography
        variant="caption"
        sx={{ color: colors.text, opacity: 0.7, fontWeight: 500 }}
      >
        {t('Recurring revenue')}
      </Typography>
      <Box className="flex flex-col gap-1">
        <Box className="flex items-center justify-between">
          <Typography
            variant="caption"
            sx={{ color: colors.text, opacity: 0.75, fontSize: '0.78rem' }}
          >
            {t('Monthly fixed')}
          </Typography>
          <MoneyLabel money={monthly ?? 0} variant="caption" />
        </Box>
        <Box className="flex items-center justify-between">
          <Typography
            variant="caption"
            sx={{ color: colors.text, opacity: 0.5, fontSize: '0.72rem' }}
          >
            {t('Annualized')}
          </Typography>
          <MoneyLabel money={annual ?? 0} variant="caption" />
        </Box>
        <Box
          className="flex items-center justify-between pt-1 mt-1 border-t"
          sx={{ borderColor: colors.selected }}
        >
          <Typography
            variant="caption"
            sx={{ color: colors.text, opacity: 0.75, fontSize: '0.78rem' }}
          >
            {t('Invoiced in period')}{' '}
            <span style={{ opacity: 0.5 }}>· {specials.invoiceCount}</span>
          </Typography>
          <MoneyLabel money={invoiced ?? 0} variant="caption" />
        </Box>
      </Box>
    </Box>
  );
};

export default ContractRevenue;
